import { useLazyQuery } from '@apollo/client'

import { APIStatus } from '@flowwai-frontend/shared/api-common'
import { FieldType } from '@flowwai-frontend/bps-officer-web/graphql'
import {
   convertToErrorType,
   getAPIStatusFromNetworkStatus
} from '@flowwai-frontend/bps-officer-web/common/data-access'

import { GSFieldType } from '../../types'

import {
   GetFieldsWithSystemFieldEnumDocument as QueryDocument,
   GetFieldsWithSystemFieldEnumQuery as Query,
   GetFieldsWithSystemFieldEnumQueryVariables as QueryVariables
} from './query.generatedTypes'
import useAPIResponseHandler from './responseHandler'

interface TriggerAPIArgsType {
   pipelineId?: string
   salesTemplateIds: string[]
   onSuccess?: () => void
   onFailure?: (error: Error) => void
}

interface APIHookReturnType {
   apiError: Error | null
   apiStatus: APIStatus
   triggerAPI: (args: TriggerAPIArgsType) => void
   fields: GSFieldType[]
}

const useGetGSFields = (): APIHookReturnType => {
   const [getFields, { data, error, networkStatus }] = useLazyQuery<
      Query,
      QueryVariables
   >(QueryDocument)
   //FIXME: cache-first is not working

   const { fields } = useAPIResponseHandler(data)

   const triggerAPI = async (args: TriggerAPIArgsType) => {
      await getFields({
         variables: {
            params: {
               pipelineId: args.pipelineId,
               salesTemplateIds: args.salesTemplateIds,
               fieldTypes: [FieldType.PhoneNumber],
               pagination: { limit: 100, offset: 0 }
            }
         },
         onCompleted: args.onSuccess,
         onError: args.onFailure
      })
   }

   return {
      apiError: convertToErrorType(error),
      apiStatus: getAPIStatusFromNetworkStatus(networkStatus, data),
      triggerAPI,
      fields
   }
}

export { useGetGSFields }
